import * as React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import CircularProgress from '@material-ui/core/CircularProgress';

const propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  caption: PropTypes.string,
  loading: PropTypes.bool,
};

const defaultProps = {
  id: null,
  className: null,
  children: null,
  caption: null,
  loading: false,
};

function FormContainer(props) {
  const { className, caption, id, loading } = props;
  return (
    <div id={id} className={classnames('page--fragment', 'sign', className)}>
      <div className="scroll--container">
        {loading ? (
          <div className="body">
            <CircularProgress />
          </div>
        ) : (
            <div className="body">
              {<div className="logo" />}
              {caption && (
                <div
                  className="caption"
                  dangerouslySetInnerHTML={{ __html: caption }}
                  style={{ textAlign: 'center' }}
                />
              )}
              {props.children}
            </div>
          )}
      </div>
    </div>
  );
}

FormContainer.propTypes = propTypes;
FormContainer.defaultProps = defaultProps;

export default FormContainer;
